import React from 'react';
import Link from 'next/link';
import { useDarkMode } from '../../utils/hooks/useDarkMode';
import styles from '../../styles/components/sections/LocationsSection.module.css';

const LocationsSection = ({ data, className = '' }) => {
    const { isDarkMode } = useDarkMode();

    // Don't render if no data or hidden
    if (!data || data.isHidden || !data.locations || data.locations.length === 0) {
        return null;
    }

    // Filter out hidden locations
    const visibleLocations = data.locations.filter(location => !location.isHidden);

    if (visibleLocations.length === 0) {
        return null;
    }

    return (
        <section className={`${styles.locationsSection} ${isDarkMode ? styles.locationsSectionDark : ''} ${className}`} data-testid="locations-section" id="locations-section">
            <div className="tw-container" data-testid="locations-container" id="locations-container">
                <div className="row" data-testid="locations-row" id="locations-row">
                    <div className="col-12" data-testid="locations-col" id="locations-col">
                        <div className={styles.locationsWrapper} data-testid="locations-wrapper" id="locations-wrapper">
                            <h2 className={`${styles.locationsTitle} ${isDarkMode ? styles.locationsTitleDark : ''}`} data-testid="locations-title" id="locations-title">
                                {data.title || 'Our Locations'}
                            </h2>
                            <p className={`${styles.locationsHeadline} ${isDarkMode ? styles.locationsHeadlineDark : ''}`} data-testid="locations-headline" id="locations-headline">
                                {data.headline}
                            </p>
                            
                            <div className={styles.locationsGrid} data-testid="locations-grid" id="locations-grid">
                                {visibleLocations.map((location, index) => (
                                    <div key={location.id || index} className={styles.locationItem} data-testid={`location-item-${index}`} id={`location-item-${index}`}>
                                        <Link 
                                            href={location.url} 
                                            target='_blank'
                                            className={`${styles.locationLink} ${isDarkMode ? styles.locationLinkDark : ''}`}
                                            data-testid={`location-link-${index}`}
                                            id={`location-link-${index}`}
                                        >
                                            <span className={styles.locationName} data-testid={`location-name-${index}`} id={`location-name-${index}`}>
                                                {location.name}
                                            </span>
                                            <span className={`${styles.locationArrow} ${isDarkMode ? styles.locationArrowDark : ''}`} data-testid={`location-arrow-${index}`} id={`location-arrow-${index}`}>
                                                →
                                            </span>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocationsSection;
